import React from 'react'
import Collection from '../common/collection'

function CollectionP({ props }) {
  return (
    <Collection
      alt="Cielo"
      src={[
        'https://volverse-negro-daniel.s3.amazonaws.com/images/15.+a%C3%A9reo57.jpg',
        'https://volverse-negro-daniel.s3.amazonaws.com/images/15.+a%C3%A9reo60.jpg',
        'https://volverse-negro-daniel.s3.amazonaws.com/images/15.+a%C3%A9reo65.jpg',
        'https://volverse-negro-daniel.s3.amazonaws.com/images/15.+a%C3%A9reo66.jpg',
        'https://volverse-negro-daniel.s3.amazonaws.com/images/15.+a%C3%A9reo74.jpg',
        'https://volverse-negro-daniel.s3.amazonaws.com/images/15.+a%C3%A9reo75.jpg',
        'https://volverse-negro-daniel.s3.amazonaws.com/images/15.+a%C3%A9reo76.jpg',
        'https://volverse-negro-daniel.s3.amazonaws.com/images/15.+a%C3%A9reo77.jpg',
        'https://volverse-negro-daniel.s3.amazonaws.com/images/15.+a%C3%A9reo78.jpg',
      ]}
    />
  )
}


export default CollectionP
